/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Content, Loader } from "rsuite";
import TopBar from "./TopBar";
import { useEffect, useState } from "react";
import Sidemenu from "./Sidemenu";
import { useStore } from "../../context/AppContext";
import { getMenu } from "../../libs/menuPermissions/getMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { moduleConstants } from "../../context/constants";
import { ModuloPermiso } from "../../types/admin-usuarios/ModuloPermiso";

export default function Layout(props: any) {
  const [loading, setLoading] = useState(true);
  const [expand, setExpand] = useState(false);
  const [crp, setCrp] = useState("");
  const { state, dispatch } = useStore();
  let location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    if (state.user.authenticated && state.user.currentperfil) {
      setLoading(true);
      if (crp !== state.user.currentperfil.name) {
        setCrp(state.user.currentperfil.name);

        if (crp !== "") navigate("/", { replace: true });
      }
      if (!sessionStorage.getItem("tksk")) {
        sessionStorage.setItem("tksk", state.user.credentials?.token || "");
      }
      getMenu(dispatch, state.user.currentperfil).then(() => {
        setLoading(false);
      });
    } else setLoading(false);
  }, [state.user.currentperfil]);

  useEffect(() => {
    if (
      state.user.authenticated &&
      state.menu.loaded &&
      state.menu.modulos &&
      location.pathname !== "/"
    ) {
      if (expand) setExpand(false);
      const mod = state.menu.modulos.find(
        (m: ModuloPermiso) => m.route === location.pathname
      );
      if (!publicRoutes.includes(location.pathname.split("/")[1])) {
        if (mod && (mod.read || mod.create || mod.update || mod.delete))
          dispatch({ type: moduleConstants.SAVE_MODULE, payload: mod });
        else {
          navigate("/", { replace: true });
        }
      }
    }
  }, [location, state.user.authenticated, state.menu.modulos]);

  return (
    <Container
      className="m-0 gray"
      style={{ minHeight: "100vh", backgroundColor: "#D0D0D0" }}
    >
      <Sidemenu expand={expand} setExpand={setExpand} />
      <Container className={state.user.authenticated ? "main-content" : ""}>
        <TopBar expand={expand} setExpand={setExpand} />
        <Content className="d-flex align-items-center p-1 p-sm-3 p-md-4 p-lg-5">
          {loading ? <Loader center size="md" /> : props.children}
        </Content>
      </Container>
    </Container>
  );
}

const publicRoutes = ["file"];
